"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleFileChange;
/**
 * Update the form's state
 *
 * @param    { SyntheticEvent }    e        event
 * @param    { Object }            value    files data
 * @param    { String }            name     html name
 */
function handleFileChange(_ref) {
  let {
    e,
    previews,
    name,
    source
  } = _ref;
  const component = this,
    props = this.props,
    state = this.state;
  delete state.status_messages[name];
  previews.forEach(function (preview, i) {
    Object.keys(preview).forEach(function (field) {
      if (preview[field] !== undefined) {
        delete state.status_messages[name + '[' + i + '][' + field + ']'];
        delete state.status_messages[name + '[' + field + ']'];
      }
    });
  });
  component.setState({
    [name]: previews,
    status_messages: state.status_messages,
    info: undefined,
    error: undefined,
    warning: undefined
  });
}
